/* Component Dependencies */
var backToTopLinkTemplate = require('templates/backToTopLink.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'backToTopLink',
    template: {
        'backToTopLink': backToTopLinkTemplate
    },
    bindEvents: function($) {
        var _self = this;
        _self.$window = $(window);
        _self.$window.on('load scroll', _self.backToTopToggle.bind(_self));
        _self.$el.on('click', _self.scrollBody);
    },
    /**
     * This function is used to show and hide the back to top button on window scroll
     *
     **/
    scrollBody: function(e) {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
        e.preventDefault();
    },
    /**
     *
     * This function is used to show hide button on window load and scroll
     *
     * 
     **/
    backToTopToggle: function() {
        var _self = this,
            elmHeight = _self.$window.height(),
            elmTop = _self.$window.scrollTop();
        if (elmTop > elmHeight) {
            _self.$el.removeClass('l-display-none').addClass('l-display-inline-block');
        } else {
            _self.$el.removeClass('l-display-inline-block').addClass('l-display-none');
        }
    }
});